export enum AIFeedbackType {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}
